

import React, { useState, useEffect } from 'react';
import { Alert } from 'react-bootstrap';
import './Notification.css';

const Notification = ({
  show,
  message,
  type = 'success',
  duration = 3000,
  onClose,
  containerClassName = '',
}) => {
  const [visible, setVisible] = useState(show);

  /** Bootstrap Alert has no "error" variant; map to "danger" (red). */
  const alertVariant = type === 'error' ? 'danger' : type;

  /** Error/danger messages stay visible at least 5s when auto-dismiss is enabled. */
  const autoHideMs =
    duration > 0 && (type === 'error' || type === 'danger')
      ? Math.max(duration, 5000)
      : duration;

  useEffect(() => {
    setVisible(show);
    
    if (show && autoHideMs > 0) {
      const timer = setTimeout(() => {
        setVisible(false);
        if (onClose) onClose();
      }, autoHideMs);
      
      return () => clearTimeout(timer);
    }
  }, [show, autoHideMs, onClose]);

  if (!visible) return null;

  return (
    <div
      className={`notification-container${containerClassName ? ` ${containerClassName}` : ''}`}
    >
      <Alert 
        variant={alertVariant} 
        dismissible 
        onClose={() => {
          setVisible(false);
          if (onClose) onClose();
        }}
        className="notification-alert"
      >
        {message}
      </Alert>
    </div>
  );
};

export default Notification;
